import { render, staticRenderFns } from "./DiagnosticTank.vue?vue&type=template&id=49bc616b"
import script from "./DiagnosticTank.vue?vue&type=script&lang=js"
export * from "./DiagnosticTank.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticTank.vue?vue&type=style&index=0&id=49bc616b&prod&lang=scss"
import style1 from "./DiagnosticTank.vue?vue&type=style&index=1&id=49bc616b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports